<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="d-flex flex-row justify-content-between w-100">
            <a class="navbar-brand" href="javascript:void(0)">App Promotion Category Management</a>
            <a class="btn btn-sm btn-primary" [routerLink]="['/lo', company_uuid, 'front', 'promotion-category', 'form']">&#43; Add Promotion Category</a>      
        </div>
    </div>
</nav>
<hr/>
<div class="row">
    <app-table #table></app-table>
</div>